import * as React from 'react';
import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import { IconChevronRight12 } from '@cian/ui-kit/icons';

import { ISalesLink } from '../../../../types/salesLink';
import { SALES_TYPE_ICONS } from './constants';

import * as styles from './SalesLink.css';

interface ISalesLinkProps {
  link: ISalesLink;
  onClick?(link: ISalesLink, event: React.MouseEvent<HTMLAnchorElement>): void;
}

export function SalesLink({ link, onClick }: ISalesLinkProps) {
  const { salesType } = link;

  const iconSource = SALES_TYPE_ICONS.get(salesType);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onClick) {
        onClick(link, event);
      }
    },
    [onClick, link],
  );

  return (
    <a className={styles['link']} href={link.url} onClick={handleClick} data-testid="SalesLink">
      <div className={styles['container']}>
        {iconSource && <img className={styles['icon']} src={iconSource} alt="" />}
        <div className={styles['content']}>
          <div className={styles['title']}>
            <ArticleHeading4 as="h4" color="text-primary-default">
              {link.title}
            </ArticleHeading4>
          </div>
          <UIText2 color="text-secondary-default">{link.text}</UIText2>
        </div>
        <div className={styles['arrow']}>
          <IconChevronRight12 color="icon-primary-default" />
        </div>
      </div>
    </a>
  );
}
